const FuzzySet = require('fuzzyset.js');

module.exports = class MatchService {
  static checkName(name1, name2) {
    // remove accents and special characteres
    name1 = name1
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]/gi, '');
    name2 = name2
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]/gi, '');

    if (MatchService.full(name1, name2)) {
      return true;
    }

    name1 = name1.split(' ');
    name2 = name2.split(' ');

    const percentage = {
      firstName: 0.71,
      lastName: 0.6
    };

    const firstName1 = name1[0];
    const firstName2 = name2[0];

    name1.shift();
    name2.shift();

    // remove empty spaces
    name1 = name1.filter(piece => piece);
    name2 = name2.filter(piece => piece);

    const lastName1 = name1.join(' ');
    const lastName2 = name2.join(' ');

    // match first name
    const matchFirstName = FuzzySet();
    matchFirstName.add(firstName1);

    const percentageMatchFirstName = matchFirstName.get(firstName2) ? matchFirstName.get(firstName2)[0][0] : 0;

    if (percentageMatchFirstName >= percentage.firstName) {
      const matchLastName = lastName1.split(' ').reduce((match, lastName1Piece) => {
        return (
          match +
          lastName2.split(' ').filter(lastName2Piece => {
            const match = FuzzySet();
            match.add(lastName1Piece);

            const percentageMatchLastName = match.get(lastName2Piece) ? match.get(lastName2Piece)[0][0] : 0;

            return percentageMatchLastName >= percentage.lastName;
          }).length
        );
      }, false);

      return matchLastName;
    }

    return false;
  }

  static full(name1, name2) {
    name1 = name1.replace(/\s/g, '');
    name2 = name2.replace(/\s/g, '');

    const match = FuzzySet();
    match.add(name1);

    const percentage = match.get(name2) ? match.get(name2)[0][0] : 0;

    return percentage >= 0.75;
  }
};
